export default "__VITE_ASSET__BfAqGIQG__"